<abp-modal [(visible)]="openIsActiveModal" (disappear)="modalClose.emit(false)">
  <ng-template #abpHeader>
    <h3>
      {{ 'RegisterService::MakeAssets' | abpLocalization }}
    </h3>
  </ng-template>

  <ng-template #abpBody>
    <form [formGroup]="form">
      <!-- Active -->
      <div class="form-check mb-1">
        <input
          type="checkbox"
          id="asset-is-active"
          class="form-check-input"
          [checked]="form.value.isActive"
          (change)="setActive(true)"
        />
        <label for="asset-is-active" class="form-check-label">
          {{ 'AbpUi::Active' | abpLocalization }}
        </label>
      </div>

      <!-- Inactive -->
      <div class="form-check mb-1">
        <input
          type="checkbox"
          id="asset-is-inactive"
          class="form-check-input"
          [checked]="!form.value.isActive"
          (change)="setActive(false)"
        />
        <label for="asset-is-inactive" class="form-check-label">
          {{ 'AbpUi::Inactive' | abpLocalization }}
        </label>
      </div>

      <!-- Recalled -->
      <div class="form-check">
        <input
          type="checkbox"
          id="asset-is-recalled"
          class="form-check-input"
          formControlName="isRecalled"
        />
        <label for="asset-is-recalled" class="form-check-label">
          {{ 'AbpUi::Recalled' | abpLocalization }}
        </label>
      </div>
    </form>

    <div class="flex gap-2" *ngIf="showMessage">
      <label class="text-black-base font-medium">
        {{ 'ServicingService::TotalSelected' | abpLocalization }}:
      </label>
      <label class="form-label"> {{ assets.length }} </label>
    </div>
  </ng-template>

  <ng-template #abpFooter>
    <button
      type="button"
      class="btn btn-primary"
      (click)="applyStatusChanges()"
      [disabled]="isBusy"
    >
      {{ 'AbpUi::Apply' | abpLocalization }}
    </button>
    <button type="button" class="btn btn-secondary" abpClose>
      {{ 'AbpUi::Close' | abpLocalization }}
    </button>
  </ng-template>
</abp-modal>
